module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lost-found-header",
    class: _vm.modeClass
  }, [_c('figure', {
    staticClass: "lost-found-avatar"
  }, [(_vm.avatar) ? _c('img', {
    staticClass: "avatar-image",
    attrs: {
      "src": _vm.avatar,
      "alt": _vm.author,
      "width": "30",
      "height": "30"
    }
  }) : _vm._e(), _vm._v(" "), _c('figcaption', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.author))])]), _vm._v(" "), _c('div', {
    staticClass: "lost-found-dates",
    class: _vm.modeClass
  }, [_c('detail-description', {
    attrs: {
      "icon": "date",
      "label": "Fecha",
      "description": _vm.date
    }
  }), _vm._v(" "), _c('detail-description', {
    attrs: {
      "icon": "time-standard",
      "label": "Hora",
      "description": _vm.time
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fadf100","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LostFoundHeader.vue
// module id = 965
// module chunks = 39 40 41 42 43 44